import React from "react";
import { observer } from "mobx-react";
import { RoleUpdateStore } from "../../store";
import { RoleUpdateForm } from "./RoleUpdateForm";
import { ErrorDialog, ConfirmCancelDialog } from "../../../../common/controls";
import { SavingOverlay } from "../../../../common/controls/forms/SavingOverlay";
import { OutdatedAfterSaveNotice } from "../../../../common/controls/forms/OutdatedAfterSaveNotice";

export type RoleUpdateProps = {
  roleUpdateStore: RoleUpdateStore;
  showToolbox?: boolean;
  showSaveFooter?: boolean;
};

export const RoleUpdate: React.FC<RoleUpdateProps> = observer(
  ({ roleUpdateStore, showToolbox = true, showSaveFooter }) => {
    return (
      <>
        <SavingOverlay open={roleUpdateStore.isSaving} />
        <OutdatedAfterSaveNotice
          open={roleUpdateStore.savedButOutdated}
          onReload={() => roleUpdateStore.reloadRole()}
          reloadDisabled={roleUpdateStore.isProcessing}
        />
        <RoleUpdateForm
          roleUpdateStore={roleUpdateStore}
          name_esError={roleUpdateStore.errors.name_es?.message}
          onName_esChange={(value: string) => {
            roleUpdateStore.setName_esValue(value);
          }}
          name_es={roleUpdateStore.entityValues.name_es}
          name_enError={roleUpdateStore.errors.name_en?.message}
          onName_enChange={(value: string) => {
            roleUpdateStore.setName_enValue(value);
          }}
          name_en={roleUpdateStore.entityValues.name_en}
          name_ptError={roleUpdateStore.errors.name_pt?.message}
          onName_ptChange={(value: string) => {
            roleUpdateStore.setName_ptValue(value);
          }}
          name_pt={roleUpdateStore.entityValues.name_pt}
          permissionsError={roleUpdateStore.errors.permissions?.message}
          onPermissionsChange={(value) => {
            roleUpdateStore.setPermissionsValue(value);
          }}
          permissionsSelectedValues={
            roleUpdateStore.entityValues.showPermissions
          }
          onPermissionsSelected={(value) => {
            roleUpdateStore.setSelectedPermissions(value);
          }}
          permissionsOptions={roleUpdateStore.getPermissionsOptions()}
          audienceError={roleUpdateStore.errors.audience?.message}
          onAudienceChange={(value: string) => {
            roleUpdateStore.setAudienceValue(value);
          }}
          audience={roleUpdateStore.entityValues.audience}
          isForAllTenantsError={roleUpdateStore.errors.isForAllTenants?.message}
          onIsForAllTenantsChange={(value: boolean) => {
            roleUpdateStore.setIsForAllTenantsValue(value);
          }}
          isForAllTenants={roleUpdateStore.entityValues.isForAllTenants}
          showToolbox={showToolbox}
          showSaveFooter={showSaveFooter}
          saving={roleUpdateStore.saveDisabled}
          onSave={() => roleUpdateStore.saveRole()}
          onCancel={() => roleUpdateStore.cancelRole()}
        />
        <ErrorDialog
          open={roleUpdateStore.errorDialogOpened}
          title={roleUpdateStore.errorTitle}
          description={roleUpdateStore.errorDescription}
          onClose={() => roleUpdateStore.closeErrorDialog()}
        />
        <ConfirmCancelDialog
          open={roleUpdateStore.confirmDialogOpened}
          title={roleUpdateStore.confirmDialogTitle}
          description={roleUpdateStore.confirmDialogDescription}
          onConfirm={() => roleUpdateStore.executeConfirmedAction()}
          onCancel={() => roleUpdateStore.closeConfirmDialog()}
        />
      </>
    );
  }
);
